import { render, staticRenderFns } from "./userRoleDetails.vue?vue&type=template&id=4c9f0921&"
import script from "./userRoleDetails.vue?vue&type=script&lang=js&"
export * from "./userRoleDetails.vue?vue&type=script&lang=js&"
import style0 from "./userRoleDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports